package co.maytes.standupbot.dashboard.lib.api

/**
 * Narrow error type for API calls. Mirrors the fields of the backend's
 * ProblemDetailsDto for 4xx/5xx responses; distinct variants cover transport
 * failures and the auth-refresh edge case.
 */
sealed interface ApiError {
    val displayMessage: String

    data class Http(
        val status: Int,
        val title: String,
        val detail: String?,
        val traceId: String?,
        val type: String? = null,
    ) : ApiError {
        override val displayMessage: String = detail ?: title
        val code: String? get() = type?.substringAfterLast('/')?.takeIf { it.isNotBlank() }
    }

    data class Network(val cause: String) : ApiError {
        override val displayMessage: String = "Network error: $cause"
    }

    data object Unauthorized : ApiError {
        override val displayMessage: String = "Session expired"
    }

    data class Unknown(val cause: String) : ApiError {
        override val displayMessage: String = "Unexpected error: $cause"
    }
}
